import { projectConfig, BSC_RPC_ENDPOINTS } from "@/config/project";

export const SELECTORS = {
  symbol: "0x95d89b41",
  decimals: "0x313ce567",
  totalSupply: "0x18160ddd",
  deadBalance: "0x70a08231000000000000000000000000000000000000000000000000000000000000dead",
};

export async function ethCall(data, signal) {
  for (const url of BSC_RPC_ENDPOINTS) {
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ jsonrpc: "2.0", id: 1, method: "eth_call", params: [{ to: projectConfig.contractAddress, data }, "latest"] }),
        signal,
      });
      const json = await res.json();
      if (json.result && json.result !== "0x") return json.result;
    } catch {
      /* try next endpoint */
    }
  }
  return null;
}

// Decode an ABI string return (or bytes32) from hex
export function decodeString(hex) {
  try {
    const raw = hex.slice(2);
    if (raw.length > 128) {
      const len = parseInt(raw.slice(64, 128), 16);
      const data = raw.slice(128, 128 + len * 2);
      return decodeURIComponent(data.replace(/../g, "%$&"));
    }
    const data = raw.replace(/0+$/, "");
    return decodeURIComponent(data.replace(/../g, "%$&"));
  } catch {
    return null;
  }
}

export function toWholeUnits(hex, decimals) {
  try {
    return BigInt(hex) / 10n ** BigInt(decimals);
  } catch {
    return null;
  }
}

export function formatUnits(hex, decimals) {
  const whole = toWholeUnits(hex, decimals);
  return whole == null ? null : Number(whole).toLocaleString("en-US");
}
